import { render, staticRenderFns } from "./projetos.vue?vue&type=template&id=7a4cac34&"
import script from "./projetos.vue?vue&type=script&lang=js&"
export * from "./projetos.vue?vue&type=script&lang=js&"
import style0 from "./projetos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports